/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { TourStateDefinition } from '@tours/models/tour-state-definition';
import { TourStatesService } from '@tours/services/tour-states.service';

@Pipe({
    name: 'numericState',
    standalone: false
})
export class NumericStatePipe implements PipeTransform {
  private states: string[];

  constructor(private tourStatesService: TourStatesService) {
    this.states = this.tourStatesService.getStateDefinitions().map((state: TourStateDefinition) => state.name);
  }

  transform(value: string, args?: any): number {
    return this.states.indexOf(value);
  }
}
